var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('loading',{attrs:{"active":_vm.$store.state.pageLoading,"is-full-page":true,"color":"#007BFF","width":128,"height":128,"opacity":0.9},on:{"update:active":function($event){return _vm.$set(_vm.$store.state, "pageLoading", $event)}}}),_c('nav-drawer'),_c('navbar'),_c('router-view'),_c('Dialog'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }